import { createRouter, createWebHashHistory } from "vue-router";
import index_not from "@/assets/index_not.svg";
import index_ac from "@/assets/index_ac.svg";
import friends_ac from "@/assets/friends_ac.svg";
import friends_not from "@/assets/friends_not.svg";
import mining_ac from "@/assets/mining_ac.svg";
import mining_not from "@/assets/mining_not.svg";
import dollar_not from "@/assets/dollar_not.svg";
import dollar_active from "@/assets/dollar_active.svg";
const routes = [
  {
    path: "/",
    component: () => import("/src/view/index.vue"),
    meta: {
      title: "home",
      icon: index_not,
      activeIcon: index_ac, //激活时候的导航图标
      isTabbar: true, //判断是不是底部导航栏
    },
  },
  {
    path: "/500",
    component: () => import("/src/view/error.vue"),
    meta: {
      title: "error",
      hideNavBar: true,
      showTabbar: false,
    },
  },
  {
    path: "/404",
    component: () => import("/src/view/notFound.vue"),
    meta: { hideNavBar: true, showTabbar: false },
  },
  {
    path: "/:pathMatch(.*)", // 必须放在末尾，否则在此之下面的路径都无法使用
    redirect: "/404",
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "-";
  }
});
export default router;
